import {
  ACTIVE_TAB,
  UPDATE_CHECKLIST,
  STEPPER,
  SELECTED_EMPLOYEES,
  UNSELECTED_EMPLOYEES,
  UPLOADED_EMPLOYEES,
  UPDATE_PAGE_IN_REDUX,
  ACTIVE_SUB_TAB,
} from "../constants/ChecklistsConstants";

const initialState = {
  checklist: {},
  step: "1",
  selectedEmployees: [],
  unSelectedEmployees: [],
  uploadedEmployees: [],
  activeTab: "1",
  activesubtab: "1",
};

const checklistReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_CHECKLIST:
      return {
        ...state,
        checklist: action.checklist,
      };
    case STEPPER:
      return {
        ...state,
        step: action.step,
      };
    case SELECTED_EMPLOYEES:
      return {
        ...state,
        selectedEmployees: action.employees,
      };
    case UNSELECTED_EMPLOYEES:
      return {
        ...state,
        unSelectedEmployees: action.employees,
      };
    case UPLOADED_EMPLOYEES:
      return {
        ...state,
        uploadedEmployees: action.employees,
      };
    case ACTIVE_TAB:
      return { ...state, activeTab: action.activeTab };

    case UPDATE_PAGE_IN_REDUX:
      const updatedPages = state.checklist.form.content.pages.map((page) => {
        if (page.id === action.pageId) {
          return {
            ...page,
            addToTotalScore: action.newValue,
          };
        }
        return page;
      });
      return {
        ...state,
        checklist: {
          ...state.checklist,
          form: {
            ...state.checklist.form,
            content: {
              ...state.checklist.form.content,
              pages: updatedPages,
            },
          },
        },
      };

    case ACTIVE_SUB_TAB:
      return { ...state, activesubTab: action.activesubTab };

    default:
      return state;
  }
};

export default checklistReducer;
